module.exports = {
  CSS_SCOPE_ID: 'own-up-styles',
  INJECTABLE_LIBRARY_NAME: 'ownUpWidgets',

  LEAD_INTAKE_API_STAGING_URL: 'https://staging.lead-intake.ownup.com',
  CLICK_OUT_API_STAGING_URL: 'https://staging.click-out.ownup.com',
  NETLIFY_FUNCTIONS_API_STAGING_URL: 'https://staging.netlify-functions.ownup.com',
  WWW_STAGING_URL: 'https://staging.www.ownup.com',
  AUTH_API_STAGING_URL: 'https://staging.auth.ownup.com',

  LEAD_INTAKE_API_PRODUCTION_URL: 'https://lead-intake.ownup.com',
  CLICK_OUT_API_PRODUCTION_URL: 'https://click-out.ownup.com',
  NETLIFY_FUNCTIONS_API_PRODUCTION_URL: 'https://netlify-functions.ownup.com',
  WWW_PRODUCTION_URL: 'https://www.ownup.com',
  AUTH_API_PRODUCTION_URL: 'https://auth.ownup.com',

  DROPDOWN_OPTION_HEIGHT: 60,
  DROPDOWN_OPTION_BUFFER: 36,

  QUESTIONNAIRE_CONTAINER_MINIMUM_HEIGHT: 600, // in pixels

  screens: {
    xs: '0px',
    sm: '512px',
    md: '768px',
    lg: '1024px',
    xl: '1280px'
  },

  colors: {
    // Primary colors
    'pine-100': '#1E4C49',
    'aloe-100': '#3E6D6A',
    'cactus-100': '#84CDAA',
    'cactus-80': '#9DD7BB',
    'mint-100': '#B9DDCC',
    'mint-80': '#C7E4D6',
    'sage-100': '#DDECE5',
    'moss-100': '#EDF5F1',
    'moss-70': '#F2F8F5',
    'moss-50': '#F6FAF8',

    // Secondary colors
    'atlantic-100': '#053C53',
    'atlantic-90': '#1E4F64',
    'walden-100': '#00769B',
    'mystic-100': '#B6E3ED',
    'mystic-80': '#C4E9F1',
    'mystic-60': '#D3EEF4',
    'mystic-40': '#E2F4F8',
    'mystic-20': '#F0F9FB',

    // Accent colors
    'mango-100': '#FFE485',
    'mango-60': '#FFEFB6',
    'mango-40': '#FFF4CE',
    'apricot-100': '#FFB21C',
    'apricot-60': '#FFD177',
    'apricot-40': '#FFE0A4',
    'apricot-10': '#FFF7E8',

    // Neutral colors
    'charcoal-100': '#1D1D1F',
    'charcoal-90': '#343435',
    'charcoal-40': '#1D1D1F66',
    'slate-100': '#657383',
    'experian-gray': '#636569',
    'fog-100': '#DBDFE2',
    'fog-60': '#E9ECEE',
    'fog-40': '#F1F2F3',
    'fog-20': '#F8F9F9',
    'fog-10': '#FBFCFC',
    'white-60': '#FFFFFF99',

    // Semantic colors
    'berry-100': '#BB2F37',
    'berry-20': '#F1D5D7',
    'berry-10': '#F8EAEB'
  }
};
